import fetch from 'unfetch'
import { component } from 'picoapp'
import { zelektor, debounce } from '@/lib/utility-functions.js'
import { formatMoney } from '@/lib/currency.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { form, input, vendorOutput, productOutput, pageLink, closeBtn, clearBtn } = zelektor(node)

    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function open() {
        node.classList.add('is-open')
        input.focus()
    }

    function close() {
        node.classList.remove('is-open')

        input.value = ''

        const e = new Event('input')
        input.dispatchEvent(e)
    }

    function clearInput() {
        input.value = ''
        const e = new Event('input')
        input.dispatchEvent(e)
    }

    function toggleClearBtn() {
        input.value.length ? clearBtn.classList.add('is-visible') : clearBtn.classList.remove('is-visible')
    }

    const inputQuery = debounce(() => {
        const { value } = input
        processQuery(value)
    }, 500)

    async function processQuery(query) {
        if (query) {
            document.querySelector('.search__content').classList.add('has-results')
            document.querySelector('.js-pageLink').classList.add('has-results')
        } else {
            document.querySelector('.search__content').classList.remove('has-results')
            document.querySelector('.js-pageLink').classList.remove('has-results')
        }
        const { products, response } = await fetchProducts(query)

        processResults(query, products, [], response)
    }

    function fetchProducts(query) {
        return fetch(
            `/search/suggest.json?q=${query}&limit=6&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,body,product_type,vendor,variants.title`
        )
            .then((r) => r.json())
            .then((data) => {
                const clerkProducts = data.resources?.results?.products || []

                const products = []
                let productsProcessed = 0

                const response = data

                return new Promise((resolve) => {
                    clerkProducts.forEach(async (p) => {
                        const data = await fetch(`/products/${p.handle}.json`)
                            .then((r) => r.json())
                            .then((p) => p.product)
                        data.url = `/products/${p.handle}`
                        products.push(data)
                        productsProcessed++

                        if (productsProcessed >= clerkProducts.length) {
                            resolve({ products, response })
                        }
                    })
                })
            })
    }

    function processResults(query, products, vendors, data) {
        const { search: strings } = window.theme.strings
        let gender_search = getCurrentGender() // returns gender_men || gender_women || empty string
        if (gender_search) {
            products = products.filter(function (p) {
                return p.tags.includes(gender_search) || p.tags.includes('gender_unisex')
            })
        }

        pageLink.innerText = strings.viewAllProducts.replace('%count%', ``)
        const vendorResults = vendors.length
            ? vendors.map((v) => `<li class="search__brands__item"><a href="${v.url}">${v.name}</a></li>`).join('')
            : `<li class="search__brands__item search__brands__item--empty">${strings.noResults}</li>`

        vendorOutput.innerHTML = vendorResults

        const productsToRender = products
        const productResults = productsToRender.length
            ? productsToRender
                  .map((p) => {
                      const { title, url, id } = p
                      const image = p.image.src
                      let { compare_at_price: comparePrice, price } = p.variants[0]

                      return `
                    <li class="search__products__item" data-clerk-product-id="${id}">
                        <a href="${url}" class="search__products__item__link"></a>
                        <figure class="search__products__item__image">
                            <img src="${image}" alt="${title}">
                        </figure>
                        <div class="search__products__item__content">
                            <p class="search__products__item__title">${title}</p>
                            <p class="search__products__item__prices">
                                <span class="search__products__item__price--current">${formatMoney(price * 100)}</span>
                                ${
                                    comparePrice && comparePrice != 0
                                        ? `<span class="search__products__item__price--compare">${formatMoney(
                                              comparePrice * 100
                                          )}</span>`
                                        : ''
                                }
                            </p>
                        </div>
                    </li>
                    `
                  })
                  .join('')
            : `<li class="search__products__item search__products__item--empty">${strings.noResults}</li>`
        productOutput.innerHTML = productResults
        Clerk('click', '*[data-clerk-product-id]')
    }

    function submitForm(e) {
        e.preventDefault()

        submitSearch()
    }

    function getCurrentGender() {
        const header = document.querySelector('#shopify-section-header header')
        if (header.classList.value.indexOf('gender--women') >= 0) return 'gender_women'
        if (header.classList.value.indexOf('gender--men') >= 0) return 'gender_men'
        return ''
    }

    function submitSearch(e) {
        if (e) e.preventDefault()

        const query = encodeURIComponent(input.value)
        const url = `/search${query.length ? '?q=' : ''}${query}`

        window.location.href = url
    }

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('search:open', () => open())

    closeBtn.addEventListener('click', close)
    node.addEventListener('click', (e) => {
        if (e.target === node) close()
    })

    clearBtn.addEventListener('click', clearInput)

    input.addEventListener('input', (e) => {
        toggleClearBtn()
        inputQuery()
    })

    form.addEventListener('submit', submitForm)

    pageLink.addEventListener('click', submitSearch)
})
